<template>
  <div>
    <container :active_path="path" :plate="'云项目'">
      <el-tabs v-model="tabsactive" tab-position="left" @tab-click="changeTabs">
        <el-tab-pane v-for="(item, index) in regions" :key="index" :label="item.label" :name="item.label">
          <div class="base-warp">
            <div class="head">
              <el-button class="btn" type="primary" size="mini" @click="save()">保存</el-button>
              <tutor-project class="btn" :regions="regions" @getProject="getProject" :selectedCity="tabsactive"></tutor-project>
            </div>
            <div class="table-box">
              <div class="t-warp">
                <transition-group name="flip-list" tag="div">
                  <div draggable="true" @dragstart="dranstart(project)" @dragend="dragend" @dragenter="dragenter(project)" v-for="(project, index) in projects" :key="index" class="item-box">
                    <el-button class="delbtn" type="danger" size="small" icon="el-icon-delete" @click="delproject(project, index)" circle></el-button>

                    <el-card class="card-custom" :body-style="{ padding: '0px' }">
                      <el-image class="img" :src="project.thumbnail" fit="scale-down" :lazy="true"></el-image>
                      <div class="house-info">
                        <p class="text name">{{ project.name }}</p>
                        <p class="text">
                          <span class="stext text-danger">{{ project.average_price }}元/㎡</span>
                          <span class="stext">{{ project.door_area }}㎡</span>
                        </p>
                        <p class="text">
                          <span class="stext">{{ project.region }}</span>
                        </p>
                        <div class="tags">
                          <div class="tag sell-tag">{{ project.sell }}</div>
                          <div class="tag" v-for="(tag, dex) in JSON.parse(project.tags)" :key="dex">{{ tag }}</div>
                        </div>
                      </div>
                    </el-card>
                  </div>
                </transition-group>
              </div>
            </div>
          </div>
        </el-tab-pane>
      </el-tabs>
    </container>
  </div>
</template>

<script>
import Container from "../../../components/container.vue";
import TutorProject from "../../../components/tutor-project.vue";
export default {
  components: {
    Container,
    TutorProject
  },
  data() {
    return {
      path: "/project/stick",
      regions: [],
      tabsactive: "",
      projects: [],
      oldNum: 0,
      newNum: 0,
      sticks: [],
      city: ""
    };
  },
  mounted() {
    let city = this.$store.getters.getuser.city;
    this.tabsactive = city;
    if (city === "全部") {
      city = "";
      this.tabsactive = "武汉";
    }
    this.city = city;
    this.getCityList();
    this.getTableData();
  },
  methods: {
    changeTabs() {
      this.projects = [];
      this.getTableData();
    },
    formateSticks() {
      var projects = this.projects;
      var arr = [];
      var i = 1;
      for (var project of projects) {
        var obj = {
          projectid: project._id["$oid"],
          index: i
        };
        arr.push(obj);
        i++;
      }
      this.sticks = arr;
    },
    getTableData() {
      var params = {
        city: this.tabsactive
      };
      this.$api.getStickProjectList(params).then((data) => {
        for (var project of data) {
          if (typeof project.door_area == "object") {
            var str1 = "";
            for (var str of project.door_area) {
              str1 = str1 + "-" + str;
            }
            project.door_area = str1.replace("-", "");
          }
        }
        this.projects = data;
        this.formateSticks();
      });
    },
    delproject(item, index) {
      this.$confirm('是否确认取消该楼盘置顶？').then(
        confirm=>{
          var params = {
            id: item._id["$oid"]
          };
          this.$api.delProjectStick(params).then((data) => {
            this.$message.success(data);
            this.projects.splice(index, 1);
            this.sticks.splice(index, 1);
          });
        },
        cancel=> {
          this.$message.info('已取消删除');
        }
      )
    },
    dranstart(value) {
      this.oldNum = value;
    },
    dragend: function() {
      if (this.oldNum != this.newNum) {
        let oldIndex = this.projects.indexOf(this.oldNum);
        let newIndex = this.projects.indexOf(this.newNum);
        let newItems = [...this.projects];
        // 删除老的节点
        newItems.splice(oldIndex, 1);
        // 在列表中目标位置增加新的节点
        newItems.splice(newIndex, 0, this.oldNum);
        // this.items一改变，transition-group就起了作用
        this.projects = [...newItems];
        this.formateSticks();
      }
    },
    dragenter: function(value) {
      this.newNum = value;
    },
    save() {
      var params = {
        sticks: JSON.stringify(this.sticks)
      };
      this.$api.editProjectStick(params).then((data) => {
        this.$message.success(data);
      });
    },
    getProject(project) {
      if (typeof project.door_area == "object") {
        var str1 = "";
        for (var str of project.door_area) {
          str1 = str1 + "-" + str;
        }
        project.door_area = str1.replace("-", "");
      }
      this.projects.push(project);
      this.formateSticks();
    },
    getCityList() {
      this.$api.getCityList("").then((data) => {
        if (this.city !== "") {
          data = data.filter((item) => {
            return item.label == this.city;
          });
        }
        this.regions = data;
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.head {
  text-align: right;
  padding: 10px 0;
  width: 100%;
  .btn {
    margin-right: 20px;
    display: inline-block;
  }
}
.table-box {
  padding: 10px;
  .t-warp {
    overflow: hidden;
    .item-box {
      float: left;
      margin-right: 10px;
      margin-bottom: 10px;
      width: 180px;
      position: relative;
      .delbtn {
        position: absolute;
        top: 0;
        right: 0;
        z-index: 10;
      }
    }
    .card-custom {
      .img {
        width: 180px;
        height: 120px;
        background: #f5f7fa;
      }
      .house-info {
        padding: 8px 6px;
        font-size: 14px;
        .text.name {
          font-size: 15px;
          font-weight: bold;
          color: #333;
          margin-bottom: 4px;
        }
        .text {
          color: #838383;
          // margin-top: 2px;
          white-space: nowrap;
          .stext {
            font-size: 14px;
            margin-right: 8px;
          }
        }
        .tags {
          width: 100%;
          overflow: hidden;
          margin-top: 8px;
          display: inline-block;
          white-space: nowrap;
          height: 24px;
          .sell-tag {
            background: #e6a23c;
            color: #fff;
            border: none;
          }
        }
      }
    }
  }
}
</style>
